// extracted by mini-css-extract-plugin
export default {"swatch--hoverable":"styles_swatch--hoverable__NDHxu"};